import { MARQUEE_TERMS } from "../data/content";

export default function Marquee() {
  const items = [...MARQUEE_TERMS, ...MARQUEE_TERMS];
  return (
    <div data-testid="editorial-marquee" className="border-y wp-rule py-5 overflow-hidden bg-[#EAF4FD]">
      <div className="marquee-track">
        {items.map((t, i) => (
          <span key={i} className="font-mono-wp text-xs uppercase tracking-[0.3em] text-[#4A5568] whitespace-nowrap flex items-center">
            <span className="px-8">{t}</span>
            <span className="text-[#2563EB]">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
